export default __webpack_public_path__ + "static/media/Snd_Try4.40045cf2.mp3";